import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getCookie } from "../utils/cookies";
import { useLoading } from "../context/LoadingContext";

const NewPass = () => {
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [showPass1, setShowPass1] = useState(false);
  const [showPass2, setShowPass2] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loaded, setLoaded] = useState(false);
  const navigate = useNavigate();
  const { startLoading, stopLoading } = useLoading();

  // Validations
  const hasLength = password1.length >= 6;
  const hasUpper = /[A-Z]/.test(password1);
  const hasNumber = /[0-9]/.test(password1);
  const hasSpecial = /[!@#$%^&*()_+\-=\[\]{};:,./<>?|]/.test(password1);
  const passMatch = password1.length > 0 && password2.length > 0 && password1 === password2;
  const passTouched = password1.length > 0;

  useEffect(() => {
    const email = localStorage.getItem("unverifiedEmail");
    if (!email) { navigate("/login"); return; }
    fetch("https://awaretherapycenter.ro/accounts/csrf-verification/", { credentials: "include" });
    requestAnimationFrame(() => setTimeout(() => setLoaded(true), 50));
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!hasLength || !hasUpper || !hasNumber || !hasSpecial) {
      setError("Parola nu îndeplinește toate cerințele."); return;
    }
    if (!passMatch) { setError("Parolele nu coincid."); return; }

    startLoading();
    const email = localStorage.getItem("unverifiedEmail");
    try {
      const response = await fetch("https://awaretherapycenter.ro/accounts/reset-password/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded", "X-CSRFToken": getCookie("csrftoken") },
        credentials: "include",
        body: new URLSearchParams({ email, new_password: password1 }),
      });
      const data = await response.json();
      if (response.ok) {
        setSuccess("Parola a fost schimbată cu succes!"); setError("");
        localStorage.removeItem("unverifiedEmail");
        localStorage.removeItem("verificationType");
        setTimeout(() => navigate("/login"), 2000);
      } else {
        setError(data.error || "Eroare la schimbarea parolei."); setSuccess("");
      }
    } catch (err) { setError("Eroare de rețea."); }
    finally { stopLoading(); }
  };

  const CheckIcon = () => (
    <svg viewBox="0 0 12 12" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 6l3 3 5-5"/></svg>
  );

  const EyeOpen = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
    </svg>
  );
  const EyeClosed = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
      <line x1="1" y1="1" x2="23" y2="23"/>
    </svg>
  );

  const css = `
    @import url('https://fonts.googleapis.com/css2?family=Cormorant:ital,wght@0,300;0,400;0,500;1,300;1,400&family=Inter:wght@300;400;500&display=swap');

    .np-nav { position: fixed; top: 0; left: 0; right: 0; z-index: 100; background: rgba(250,247,242,0.92); backdrop-filter: blur(30px); -webkit-backdrop-filter: blur(30px); }
    .np-nav-inner { max-width: 1400px; margin: 0 auto; padding: 28px 48px; display: flex; align-items: center; justify-content: space-between; }
    .np-nav-logo { font-family: 'Cormorant', Georgia, serif; font-size: 22px; font-weight: 400; letter-spacing: 5px; text-transform: uppercase; color: #074F4F; text-decoration: none; }
    .np-nav-links { display: flex; gap: 44px; list-style: none; padding: 0; margin: 0; }
    .np-nav-links a { font-family: 'Inter', sans-serif; font-size: 12px; font-weight: 500; letter-spacing: 2px; text-transform: uppercase; color: #2d2d2d; text-decoration: none; transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1); position: relative; padding-bottom: 4px; }
    .np-nav-links a::after { content: ''; position: absolute; bottom: 0; left: 0; width: 100%; height: 1px; background: #074F4F; transform: scaleX(0); transform-origin: right; transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1); }
    .np-nav-links a:hover::after { transform: scaleX(1); transform-origin: left; }
    .np-nav-links a:hover { color: #074F4F; }

    .np-grain { position: fixed; inset: 0; z-index: 10; pointer-events: none; opacity: 0.02; background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E"); background-size: 128px; }

    .np-scene { min-height: 100vh; padding-top: 100px; padding-bottom: 60px; display: flex; align-items: center; justify-content: center; position: relative; overflow: hidden; background: #FAF7F2; }
    .np-scene::before { content: ''; position: absolute; top: -20%; right: -10%; width: 600px; height: 600px; border-radius: 50%; background: radial-gradient(circle, rgba(218,235,219,0.25) 0%, transparent 70%); pointer-events: none; }
    .np-scene::after { content: ''; position: absolute; bottom: -15%; left: -8%; width: 500px; height: 500px; border-radius: 50%; background: radial-gradient(circle, rgba(245,225,208,0.2) 0%, transparent 70%); pointer-events: none; }

    .np-content { position: relative; z-index: 2; max-width: 480px; width: 100%; padding: 0 24px; text-align: center; opacity: 0; transform: translateY(40px); transition: all 1s cubic-bezier(0.16, 1, 0.3, 1) 0.2s; }
    .np-scene.loaded .np-content { opacity: 1; transform: translateY(0); }

    .np-icon { width: 64px; height: 64px; border-radius: 50%; border: 1.5px solid #C6A769; display: flex; align-items: center; justify-content: center; margin: 0 auto 32px; color: #C6A769; }

    .np-heading { font-family: 'Cormorant', Georgia, serif; font-size: 36px; font-weight: 300; color: #074F4F; letter-spacing: -0.02em; margin-bottom: 12px; }
    .np-sub { font-family: 'Inter', sans-serif; font-size: 14px; font-weight: 300; color: #8a8a8a; line-height: 1.6; margin-bottom: 36px; }

    .np-card { background: #fff; padding: 40px 36px; text-align: left; box-shadow: 0 1px 3px rgba(7,79,79,0.02), 0 8px 32px rgba(7,79,79,0.04), 0 24px 60px rgba(7,79,79,0.03); position: relative; }
    .np-card::before { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 2px; background: #C6A769; transform: scaleX(0); transform-origin: left; transition: transform 1.2s cubic-bezier(0.16, 1, 0.3, 1) 0.6s; }
    .np-scene.loaded .np-card::before { transform: scaleX(1); }

    .np-field { margin-bottom: 24px; }
    .np-label { display: block; font-family: 'Inter', sans-serif; font-size: 9px; font-weight: 500; letter-spacing: 3px; text-transform: uppercase; color: #074F4F; margin-bottom: 10px; }
    .np-input-wrap { position: relative; }
    .np-input { width: 100%; height: 52px; padding: 0 18px; padding-right: 44px; font-family: 'Inter', sans-serif; font-size: 14px; font-weight: 300; color: #2d2d2d; background: #FAF7F2; border: 1px solid transparent; border-radius: 0; outline: none; transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1); -webkit-appearance: none; }
    .np-input:focus { background: #fff; border-color: #C6A769; box-shadow: 0 0 0 3px rgba(198,167,105,0.06); }
    .np-input::placeholder { color: #b5b5b5; font-weight: 300; }
    .np-eye { position: absolute; right: 14px; top: 50%; transform: translateY(-50%); background: none; border: none; cursor: pointer; color: #b5b5b5; padding: 4px; display: flex; align-items: center; transition: color 0.3s; }
    .np-eye:hover { color: #074F4F; }

    .np-checks { display: flex; flex-direction: column; gap: 5px; margin-top: 10px; }
    .np-check { display: flex; align-items: center; gap: 8px; font-family: 'Inter', sans-serif; font-size: 11px; font-weight: 400; color: #b5b5b5; transition: color 0.3s cubic-bezier(0.16, 1, 0.3, 1); }
    .np-check.valid { color: #5a9a6a; }
    .np-check-icon { width: 15px; height: 15px; border-radius: 50%; border: 1.5px solid #d4d4d4; display: flex; align-items: center; justify-content: center; flex-shrink: 0; transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1); }
    .np-check.valid .np-check-icon { border-color: #5a9a6a; background: #5a9a6a; }
    .np-check-icon svg { width: 9px; height: 9px; opacity: 0; transform: scale(0.5); transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1); }
    .np-check.valid .np-check-icon svg { opacity: 1; transform: scale(1); }

    .np-error { font-family: 'Inter', sans-serif; font-size: 12px; color: #b33; background: rgba(187,51,51,0.04); border-left: 2px solid #C6A769; padding: 12px 16px; margin-top: 16px; line-height: 1.5; }
    .np-success { font-family: 'Inter', sans-serif; font-size: 12px; color: #5a9a6a; background: rgba(90,154,106,0.06); border-left: 2px solid #5a9a6a; padding: 12px 16px; margin-top: 16px; line-height: 1.5; }

    .np-submit { width: 100%; height: 52px; margin-top: 24px; font-family: 'Inter', sans-serif; font-size: 10px; font-weight: 500; letter-spacing: 3.5px; text-transform: uppercase; color: #074F4F; background: #C6A769; border: none; cursor: pointer; position: relative; overflow: hidden; transition: transform 0.2s; }
    .np-submit::before { content: ''; position: absolute; inset: 0; background: #fff; transform: translateY(101%); transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1); }
    .np-submit:hover::before { transform: translateY(0); }
    .np-submit span { position: relative; z-index: 1; }
    .np-submit:active { transform: scale(0.98); }

    .np-footer { background: #074F4F; padding: 80px 48px 32px; }
    .np-f-inner { max-width: 1200px; margin: 0 auto; }
    .np-f-grid { display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; gap: 48px; margin-bottom: 56px; }
    .np-f-brand-name { font-family: 'Cormorant', Georgia, serif; font-size: 22px; font-weight: 400; letter-spacing: 5px; text-transform: uppercase; color: #FAF7F2 !important; margin-bottom: 14px; }
    .np-footer p { font-family: 'Inter', sans-serif !important; font-size: 13px !important; line-height: 1.7 !important; color: rgba(250,247,242,0.4) !important; max-width: 260px; }
    .np-f-social { display: flex; gap: 16px; margin-top: 24px; }
    .np-f-social a { width: 36px; height: 36px; border: 1px solid rgba(198,167,105,0.25); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-family: 'Inter', sans-serif; font-size: 11px; letter-spacing: 1px; text-transform: uppercase; color: rgba(250,247,242,0.5) !important; text-decoration: none; transition: all 0.3s; }
    .np-f-social a:hover { background: #C6A769; border-color: #C6A769; color: #074F4F !important; }
    .np-f-col h5 { font-family: 'Inter', sans-serif; font-size: 10px; font-weight: 500; letter-spacing: 2px; text-transform: uppercase; color: #C6A769 !important; margin-bottom: 20px; }
    .np-f-col ul { list-style: none; padding: 0; margin: 0; }
    .np-f-col li { margin-bottom: 12px; }
    .np-f-col a { font-family: 'Inter', sans-serif; font-size: 13px; color: rgba(250,247,242,0.4) !important; text-decoration: none; transition: color 0.3s; }
    .np-f-col a:hover { color: #C6A769 !important; }
    .np-f-divider { height: 1px; background: linear-gradient(90deg, transparent, rgba(198,167,105,0.2), transparent); margin-bottom: 32px; }
    .np-f-bottom { display: flex; justify-content: space-between; font-family: 'Inter', sans-serif; font-size: 11px; color: rgba(250,247,242,0.25) !important; }
    .np-f-bottom a { color: rgba(250,247,242,0.25) !important; margin-left: 20px; text-decoration: none; transition: color 0.3s; }
    .np-f-bottom a:hover { color: #C6A769 !important; }

    @media (max-width: 1024px) { .np-nav-links { display: none; } .np-f-grid { grid-template-columns: repeat(2, 1fr); } }
    @media (max-width: 600px) { .np-card { padding: 32px 24px; } .np-heading { font-size: 28px; } .np-nav-inner { padding: 20px 24px; } .np-footer { padding: 60px 24px 24px; } .np-f-grid { grid-template-columns: 1fr; } }
  `;

  return (
    <div>
      <style>{css}</style>

      <nav className="np-nav">
        <div className="np-nav-inner">
          <a href="/" className="np-nav-logo">Aware</a>
          <ul className="np-nav-links">
            <li><a href="/">Acasă</a></li>
            <li><a href="/despre-noi">Despre noi</a></li>
            <li><a href="/servicii">Servicii</a></li>
            <li><a href="/evenimente">Evenimente</a></li>
            <li><a href="/#contact">Contact</a></li>
          </ul>
        </div>
      </nav>

      <div className={"np-scene" + (loaded ? " loaded" : "")}>
        <div className="np-grain" />
        <div className="np-content">
          <div className="np-icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 9.9-1"/>
            </svg>
          </div>
          <h1 className="np-heading">Parola nouă</h1>
          <p className="np-sub">Alege o parolă puternică pentru contul tău Aware</p>

          <div className="np-card">
            <form onSubmit={handleSubmit}>
              <div className="np-field">
                <label className="np-label">Parola nouă</label>
                <div className="np-input-wrap">
                  <input
                    className="np-input"
                    type={showPass1 ? "text" : "password"}
                    value={password1}
                    onChange={(e) => { setPassword1(e.target.value); setError(""); }}
                    placeholder="••••••••"
                    required
                  />
                  <button type="button" className="np-eye" onClick={() => setShowPass1(!showPass1)} tabIndex={-1}>
                    {showPass1 ? <EyeClosed /> : <EyeOpen />}
                  </button>
                </div>
              </div>

              <div className="np-field">
                <label className="np-label">Confirmă parola</label>
                <div className="np-input-wrap">
                  <input
                    className="np-input"
                    type={showPass2 ? "text" : "password"}
                    value={password2}
                    onChange={(e) => { setPassword2(e.target.value); setError(""); }}
                    placeholder="••••••••"
                    required
                  />
                  <button type="button" className="np-eye" onClick={() => setShowPass2(!showPass2)} tabIndex={-1}>
                    {showPass2 ? <EyeClosed /> : <EyeOpen />}
                  </button>
                </div>
              </div>

              {passTouched && (
                <div className="np-checks">
                  <div className={"np-check" + (hasLength ? " valid" : "")}>
                    <span className="np-check-icon"><CheckIcon /></span>
                    Minim 6 caractere
                  </div>
                  <div className={"np-check" + (hasUpper ? " valid" : "")}>
                    <span className="np-check-icon"><CheckIcon /></span>
                    O literă mare
                  </div>
                  <div className={"np-check" + (hasNumber ? " valid" : "")}>
                    <span className="np-check-icon"><CheckIcon /></span>
                    O cifră
                  </div>
                  <div className={"np-check" + (hasSpecial ? " valid" : "")}>
                    <span className="np-check-icon"><CheckIcon /></span>
                    Un caracter special
                  </div>
                  <div className={"np-check" + (passMatch ? " valid" : "")}>
                    <span className="np-check-icon"><CheckIcon /></span>
                    Parolele coincid
                  </div>
                </div>
              )}

              {error && <div className="np-error">{error}</div>}
              {success && <div className="np-success">{success}</div>}

              <button type="submit" className="np-submit"><span>Schimbă parola</span></button>
            </form>
          </div>
        </div>
      </div>

      <footer className="np-footer">
        <div className="np-f-inner">
          <div className="np-f-grid">
            <div>
              <div className="np-f-brand-name">Aware</div>
              <p>Un spațiu sigur pentru conștientizare, echilibru și sprijin emoțional.</p>
              <div className="np-f-social"><a href="#">Ig</a><a href="#">Fb</a><a href="#">Tk</a></div>
            </div>
            <div className="np-f-col"><h5>Servicii</h5><ul><li><a href="#">Terapie Individuală</a></li><li><a href="#">Terapie de Cuplu</a></li><li><a href="#">Familie &amp; Parenting</a></li><li><a href="#">Anxietate &amp; Depresie</a></li></ul></div>
            <div className="np-f-col"><h5>Terapeuți</h5><ul><li><a href="#">Alexandra Strambeanu</a></li><li><a href="#">Luna Cosmari</a></li><li><a href="#">Bianca Istratescu</a></li><li><a href="#">Kathrin Moculity</a></li></ul></div>
            <div className="np-f-col"><h5>Aware</h5><ul><li><a href="/despre-noi">Despre noi</a></li><li><a href="/#contact">Contact</a></li><li><a href="/evenimente">Evenimente</a></li><li><a href="/blog">Blog</a></li></ul></div>
          </div>
          <div className="np-f-divider"></div>
          <div className="np-f-bottom">
            <span>© 2025 Aware — Centru de Psihoterapie</span>
            <div><a href="/conditii">Termeni</a><a href="/confidentialitate">Confidențialitate</a></div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default NewPass;
